import Table_Settings from "../../../../../core/gd-modules/tasks-view/table/manager/settings/settings"
import TasksView_LocalSettings from "../../../../../core/gd-modules/tasks-view/core/settings/local/local-settings"
import {ViewType} from "../../../../../core/gd/const/views/view-type"
import {SystemColumnType} from "../../../../../core/gd-modules/manager/columns/types"
import ReportTimeReports_Settings from "../../../../../core/model2/report/reports/time-reports/table/settings"
import {AggregateFunctionType} from "../../../../../core/data-structures/aggregators/types";

export const TimeReportTable_defaultAppSettings = {
    columns: [
        {
            id: SystemColumnType.TITLE
        },
        {
            id: SystemColumnType.TIME_REPORTED,
            aggregateFunction: AggregateFunctionType.SUM
        },
        {
            id: SystemColumnType.REPORTED_BY,
            aggregateFunction: AggregateFunctionType.USERS_UNION
        },
        {
            id: SystemColumnType.REPORT_WORK_ITEM
        },
        {
            id: SystemColumnType.TASK_ID
        },
        {
            id: SystemColumnType.ESTIMATE,
            aggregateFunction: AggregateFunctionType.SUM
        },
        {
            id: SystemColumnType.SPENT_ESTIMATE,
            aggregateFunction: AggregateFunctionType.TOTAL_SPENT_ESTIMATE
        },
        {
            id: SystemColumnType.REPORT_DATE
        },
        {
            id: SystemColumnType.REPORT_IS_BILLABLE,
            aggregateFunction: AggregateFunctionType.CHECKED_TOTAL
        },
        {
            id: SystemColumnType.REPORT_MESSAGE
        },
        {
            id: SystemColumnType.COST_INTERNAL,
            aggregateFunction: AggregateFunctionType.SUM
        },
        {
            id: SystemColumnType.COST_EXTERNAL,
            aggregateFunction: AggregateFunctionType.SUM
        },
        {
            id: SystemColumnType.ESTIMATED_COST_INTERNAL,
            aggregateFunction: AggregateFunctionType.SUM
        },
        {
            id: SystemColumnType.ESTIMATED_COST_EXTERNAL,
            aggregateFunction: AggregateFunctionType.SUM
        }
    ],
    sortBy              : null,
    filters             : {},
    areEmptyFoldersHidden: false,
}

// No persistence — settings always start from defaults and are never written to localStorage
class NoopLocalSettings extends TasksView_LocalSettings {
    constructor() {
        super("")
    }

    protected _readFromLocalStorage(): any  {
        return {}
    }

    protected _writeToLocalStorage(_: any)  {

    }
}

export default class TimeReportTable_Settings extends Table_Settings {

    public reportSettings: ReportTimeReports_Settings

    constructor(reportSettings: ReportTimeReports_Settings, storedTableSettings?: any) {

        super(storedTableSettings || TimeReportTable_defaultAppSettings, new NoopLocalSettings(), TimeReportTable_defaultAppSettings)

        this.reportSettings = reportSettings

        this._areAddRowsHidden = true
    }

    get autoSave() {
        return !!this.autoSaveFunction
    }

    get systemType() {
        return ViewType.REPORT_TIME_REPORTS
    }
}
